import React from 'react'
import { useEffect, useState } from "react";
import LogoSvg from "../assets/images/svg/logo.png"



const ComingSoon = () => {
    const [time, setTime] = useState({ hours: 24, minutes: 0, seconds: 0 });

    useEffect(() => {
        const countdownInterval = setInterval(() => {
            setTime((prevTime) => {
                let { hours, minutes, seconds } = prevTime;
                if (seconds > 0) {
                    seconds -= 1;
                } else {
                    if (minutes > 0) {
                        minutes -= 1;
                        seconds = 59;
                    } else if (hours > 0) {
                        hours -= 1;
                        minutes = 59;
                        seconds = 59;
                    } else {
                        clearInterval(countdownInterval);
                    }
                }
                return { hours, minutes, seconds };
            });
        }, 1000);

        return () => clearInterval(countdownInterval);
    }, []);

    const formatNumber = (num) => num.toString().padStart(2, "0").split("");

    return (
        <>
            <section className="coming-section-two" id="coming_soon_section">
                <div className="container coming-soon-container">
                    <div className="coming-soon-logo d-flex justify-content-center">
                        <img src={LogoSvg} alt="logo" />
                    </div>
                    <h1 className="coming-soon-text">COMING SOON!</h1>
                    <div className="countdown">
                        {["hours", "minutes", "seconds"].map((unit) => (
                            <div className={`bloc-time ${unit}`} key={unit}>
                                <div className="bloc-time-sub" data-init-value={time[unit]}>
                                    {formatNumber(time[unit]).map((digit, index) => (
                                        <div className={`figure ${unit} ${unit}-${index + 1}`} key={index}>
                                            <span className="top">{digit}</span>
                                            <span className="top-back"><span>{digit}</span></span>
                                            <span className="bottom">{digit}</span>
                                            <span className="bottom-back"><span>{digit}</span></span>
                                        </div>
                                    ))}
                                </div>
                                <span className="count-title">{unit.charAt(0).toUpperCase() + unit.slice(1)}</span>
                            </div>
                        ))}
                    </div>
                    <div className="coming-soon-subscribe">
                        <input type="text" placeholder="Enter Your Email" name='EntEmail' />
                        <div className="coming-soon-subscribe-btn">
                            <div className="button" data-text="Subscribe">
                                <span>Subscribe</span>
                            </div>
                        </div>
                    </div>
                    <p className="count-title-sub">We are working very hard on the new version of our site.</p>
                </div>
            </section>
        </>
    )
}

export default ComingSoon